import {
  CLUB_SIGNUP_SUCCESS,
  CLUB_SIGNUP_VIRTUAL_SUCCESS,
  CLUB_SIGNUP_OBJECT_REQUESTING,
  RESET_CLUB_SIGNUP_ISFETCHING,
  MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE,
  MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE,
  CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_REQUESTING,
  CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_SUCCESS,
  RESET_CLUB_SIGNUP_FULLSTEAM_WALLET_ISFETCHING,
  UPDATE_CLUB_SIGNUP_FREQUENCY_REQUEST,
  UPDATE_CLUB_SIGNUP_ITEM_SELECTION_REQUEST
} from './constants';

const INITIAL_STATE = {
  data: null,
  virtualCart: null,
  virtualClub: null, // this is used to store the club data which we need when submitting but is not on the VC, primarly the subscription frequency
  isObjectFetching: false,
  isMobileClubSummaryVisible: false,
  fullSteamAuth: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_SIGNUP_ISFETCHING: {
      return {
        ...state,
        isObjectFetching: false
      };
    }
    case CLUB_SIGNUP_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case CLUB_SIGNUP_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    case CLUB_SIGNUP_VIRTUAL_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        virtualCart: data,
        isObjectFetching: false
      };
    }
    case MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE: {
      return {
        ...state,
        isMobileClubSummaryVisible: true
      };
    }
    case MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE: {
      return {
        ...state,
        isMobileClubSummaryVisible: false
      };
    }
    case CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_REQUESTING: {
      return {
        ...state,
        fullSteamAuth: { isFetching: true }
      };
    }

    case CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET_SUCCESS: {
      const data = action.payload;

      const newData = {
        ...data,
        isFetching: false
      };

      return {
        ...state,
        fullSteamAuth: newData
      };
    }

    case RESET_CLUB_SIGNUP_FULLSTEAM_WALLET_ISFETCHING: {
      return {
        ...state,
        fullSteamAuth: { isFetching: false }
      };
    }

    case UPDATE_CLUB_SIGNUP_FREQUENCY_REQUEST: {
      const { frequency } = action;
      return {
        ...state,
        virtualClub: {
          ...state.virtualClub,
          frequency
        }
      };
    }

    case UPDATE_CLUB_SIGNUP_ITEM_SELECTION_REQUEST: {
      const { itemSelection } = action;
      return {
        ...state,
        virtualClub: {
          ...state.virtualClub,
          itemSelection
        }
      };

      const data = { ...state.data };
      data.itemSelection = itemSelection;

      return {
        ...state,
        data: data
      };
    }

    default:
      return state;
  }
};

export default reducer;
